export default {
  SET_STREAMS(state, streams) {
    state.streams = streams
  }
}
